<template>
  <div class="container g-rela">
    <!--  标题图片  -->
    <div class="menu-title g-flex g-row-center">
      <img src="@/assets/home/left-menu-title.png" alt="" class="title-img g-m-t-10">
    </div>
    <!--  菜单列表  -->
    <div class="menu-list g-p-b-14 ">
      <div class="menu-item g-rela"
           @click="selectMenu(0)"
           @mouseenter="showMenu(0,null,true)">
        <div class="active-line" v-if="tagIndex === 0"></div>
        <div class="menu-padding g-flex blue-text">
          <img src="@/assets/home/left-menu-1.png" class="menu-img" alt="">
          <p class="g-m-l-8 g-nowrap g-flex-1">精选课程</p>
          <div class=""><i class="el-icon-arrow-right"></i></div>
        </div>
      </div>
      <div
          v-for="(item,index) in classifyList"
          class="menu-item g-rela"
          @click="selectMenu(index+1)"
          @mouseenter="showMenu(index+1,item,null)">
        <div class="active-line" v-if="tagIndex === index+1"></div>
        <div class="menu-padding g-flex g-row-between blue-text">
          <img :src="item.webIcon" class="menu-img" alt="">
          <p class="g-nowrap g-m-l-8  g-flex-1">{{ item.name }}</p>
          <div class=""><i class="el-icon-arrow-right"></i></div>
        </div>
      </div>

    </div>
    <!--  浮动窗口  -->
    <div class="fixed-box"
         v-if="showFixedBox"
         v-loading="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.5)"
         @mouseleave="mouseLeave"
         :style="{'top':(menuIndex+1)*20 + 'px'}">
      <div class="g-p-20">
        <div class="g-flex" v-if="childrenList.length>0">
          <div class="str-line"></div>
          <p class="g-m-l-5 g-font-14 main-text">{{ childrenTitle }}课程分类</p>
          <router-link class="g-flex-right g-font-14 main-text" :to="'/course-list?courseClassifyOne='+parentId">更多 <i
              class="el-icon-arrow-right"></i></router-link>
        </div>
        <div class="g-flex g-flex-wrap">
          <a class="sort-item" target="_blank" v-for="item in childrenList" :key="item.id"
             :href="'/#/course-list?courseClassifyOne='+parentId+'&courseClassifyTwo='+item.id">{{ item.name }}</a>
        </div>
        <!--        <div class="g-flex g-m-t-25">-->
        <!--          <div class="str-line"></div>-->
        <!--          <p class="g-m-l-5 g-font-14 main-text">推荐课程</p>-->
        <!--        </div>-->
        <div class="g-m-t-10 g-flex">
          <div class="course-item g-m-r-10 g-m-b-10" v-for="item in dataList[menuIndex]">
            <div class="poster-box g-rela" @mouseenter="doAnimate" @mouseleave="endAnimate">
              <div class="mask g-flex g-row-center" v-if="isHover">
                <router-link :to="'/course-detail/'+item.id"
                             class="submit-btn g-flex g-row-center animate__animated animate__bounceIn">学习
                </router-link>
              </div>
              <img :src="item.cover" class="poster-img" alt="">
            </div>
            <div class="infos g-p-b-10">
              <div class="g-p-l-10 g-p-r-10 g-font-12">
                <p class="g-show-1-line g-p-t-5">{{ item.nameEllipsis }}</p>
                <p class="g-m-t-10"><span class="green-text">{{ item.studyCount }}</span>学习过</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getWebHomeClassify,
  getHomeCourseList
} from "@/api/home.js"

export default {
  name: "left-menu",
  data() {
    return {
      menuIndex: 0,//当前菜单下标
      tagIndex: 0,//被点击的菜单下标
      showFixedBox: false,
      loading: true,//浮动窗口数据加载遮罩
      isHover: false,
      classifyList: [],
      childrenList: [],
      parentId: null,
      childrenTitle: null,
      dataList: []

    }
  },
  created() {
    //分类
    this.getClassify()
  },
  methods: {    //分类查询
    getClassify() {
      getWebHomeClassify().then(res => {
        this.classifyList = res
      })
    },
    queryHomeCourseList(index, classifyLevelOne, isGood) {
      this.loading = true
      getHomeCourseList({
        classifyLevelOne,
        isGood
      }).then(res => {
        this.loading = false
        this.dataList[index] = res
      }, error => {
        this.loading = false
      })
    },
    // 菜单点击
    selectMenu(val) {
      this.tagIndex = val
    },
    // 鼠标移到菜单上
    showMenu(val, item, isGood) {
      this.loading = false
      this.parentId = null
      this.childrenList = []
      if (item) {
        this.parentId = item.id
        this.childrenTitle = item.name
        this.childrenList = item.children
      }

      this.menuIndex = val
      this.showFixedBox = true
      if (!this.dataList[val]) {
        this.queryHomeCourseList(val, this.parentId, isGood)
      }
    },
    //  鼠标从浮窗移除
    mouseLeave() {
      this.showFixedBox = false
      this.loading = true
    },
    //鼠标移入的事件
    doAnimate() {
      setTimeout(() => {
        this.isHover = true
      }, 100)
    },
    //  鼠标移除事件
    endAnimate() {
      setTimeout(() => {
        this.isHover = false
      }, 100)
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-list {
  background: #fff;
}

.menu-title {
  width: 260px;
  height: 60px;
  background: linear-gradient(90deg, #52cafe, #87a5fc 100%);
  border-radius: 5px 5px 0 0;

  .title-img {
    width: 245px;
    height: 37px;
  }
}

.main-text {
  cursor: pointer;
  text-decoration: none;
}

.menu-item {
  width: 260px;
  cursor: pointer;
}

.menu-item:hover {
  background: #E9F2FF;
  transition: all ease-in 0.2s;
}

.menu-padding {
  padding: 15px 77px 15px 43px;
}

.menu-img {
  width: 22px;
  height: 22px;
}


.active-line {
  width: 4px;
  height: 30px;
  background: #5c6bff;
  position: absolute;
  left: 0;
  top: 10px;
}

.fixed-box {
  position: absolute;
  right: -500px;
  background: #ebf2fe;
  z-index: 97;
  width: 500px;
  height: 340px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.05);
  border-radius: 0 5px 5px 0;
}

.str-line {
  width: 3px;
  height: 14px;
  background: #407aff;
  border-radius: 4px;
}

.sort-item {
  background: #407aff;
  border-radius: 20px;
  font-size: 12px;
  padding: 4px 20px;
  color: #fff;
  margin: 10px 10px 0 0;
  cursor: pointer;
  text-decoration: none;
}

.poster-img {
  width: 150px;
  height: 95px;
  border-radius: 5px 5px 0 0;
  display: block;
}

.mask {
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  top: 0;
  left: 0;
  width: 150px;
  height: 95px;
  border-radius: 5px;
  cursor: pointer;
}

.infos {
  width: 150px;
  background: #fff;
  border-radius: 0 0 5px 5px;
}

.submit-btn {
  padding: 3px 12px;
}
</style>
